import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import {
  getRequestTypeStage,
  getRequestTypeDocs,
  checkPrevNomineeApi,
  createNomineeModifyRequestApi,
  activeNomineeModifyRequestApi,
  getNomineeStageApi,
} from "designs/v1/pages/ModifyKyc/services";

const CheckPrevRequest = ({
  stageScreen,
  setStageScreen,
  setStep,
  setIsContinue,
  isLoading,
  setIsLoading,
  activeUserDetail,
}) => {
  const [prevReqData, setPrevReqData] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    console.log(activeUserDetail);
    const loadPrevReqInfo = async () => {
      let payload = {
        request_type: stageScreen,
        client: activeUserDetail.client,
        pan_no: activeUserDetail.poi?.[0]?.pan_number,
        active_mobile_no: activeUserDetail.phone,
        active_kyc: activeUserDetail.name,
      };
      try {
        const resp = await checkPrevNomineeApi(payload);
        console.log("resp", resp.data.data);
        setIsLoading(false);
        if (["PENDING", "INPROGRESS"].includes(resp.data?.data?.status)) {
          setPrevReqData(resp.data.data);
          localStorage.setItem(
            "NomineeRequestNumber",
            resp.data?.data?.rekyc_modi_request_name
          );
        } else {
          handleCreateRequest();
        }
      } catch (error) {
        console.log("err", error);
        setIsLoading(false);
      }
    };
    loadPrevReqInfo();
  }, []);

  const getModifyStage = async () => {
    setIsLoading(true);
    try {
      let payload = {
        request_type: stageScreen,
        doc_name: localStorage.getItem("NomineeRequestNumber"),
      };
      const resp = await getNomineeStageApi(payload);
      let stageList = resp.data?.data?.RekycRequests_flow_status || [];
      let pageName = 0;
      for (let index = 0; index < stageList.length; index++) {
        const element = stageList[index];
        if (pageName === 0) {
          if (element?.changes_in_which_account_data?.status === 0) {
            pageName = "DematUccForm";
          } else if (element?.modification_details?.status === 0) {
            pageName = "WishToAddNominee";
          } else if (element?.review?.status === 0) {
            pageName = "NomineeModificationReview";
          } else if (
            element?.requested_for__esignature?.status === 0 ||
            element?.requested_for__esignature?.status === 1
          ) {
            pageName = "NomineeModificationESignature";
          }
        }
      }
      setIsLoading(false);
      return pageName;
    } catch (error) {
      const { data } = error.response || {};
      toast.error(
        data.message?.message || "Internal server error!"
      );
      setIsLoading(false);
    }
  };

  const handleCreateRequest = async () => {
    setIsLoading(true);
    const requestTypes = getRequestTypeStage();
    const payload = {
      request_type: stageScreen,
      full_name: activeUserDetail.full_name,
      client: activeUserDetail.client,
      active_mobile_no: activeUserDetail.phone,
      active_email_id: activeUserDetail.email,
      active_pan: activeUserDetail.poi?.[0]?.pan_number,
      active_kyc: activeUserDetail.name,
      multiple_modification: requestTypes?.length ? 1 : 0,
      doctype_name: activeUserDetail.doctype,
      existing_customer: activeUserDetail.existing_customer,
    };
    try {
      const resp = await createNomineeModifyRequestApi(payload);
      if (!resp.data?.data?.request_number) {
        setIsLoading(false);
        return toast.error("Internal server error!");
      }
      localStorage.setItem(
        "NomineeRequestNumber",
        resp.data?.data?.request_number
      );
      setIsLoading(false);
      setStep("DematUccForm");
      // try {
      //   let payload = {
      //     request_type: stageScreen,
      //     doc_name: resp.data?.data?.request_number,
      //     total_shares_of_nominee: activeUserDetail.total_shares_of_nominee,
      //     skip_nomination: activeUserDetail.skip_nomination,
      //     nomination_count: activeUserDetail.nomination_count,
      //     active_nominee: activeUserDetail.nominations?.map((item) => {
      //       return {
      //         ...item,
      //         nominee_dob:
      //           item.nominee_dob && item.nominee_dob.split("-").reverse().join("-"),
      //         guardian_dob:
      //           item.guardian_dob && item.guardian_dob.split("-").reverse().join("-"),
      //         parent: resp.data?.data?.request_number,
      //         parenttype: stageScreen,
      //       };
      //     }),
      //   };
      //   await activeNomineeModifyRequestApi(payload);
      //   setIsLoading(false);
      //   setStep("DematUccForm");
      // } catch (error) {
      //   setIsLoading(false);
      // }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const onSubmit = async (value) => {
    if (value === "Yes") {
      const docName = localStorage.getItem("NomineeRequestNumber");
      const requestTypes = getRequestTypeStage();
      const requestTypesDocs = getRequestTypeDocs() || [];
      requestTypesDocs.push(docName);
      if (requestTypes && requestTypes.length > 0) {
        const resp = await getModifyStage();
        if (
          ![
            "NomineeModificationReview",
            "NomineeModificationESignature",
          ].includes(resp)
        ) {
          return setStep(resp);
        }
        requestTypes.shift();
        localStorage.setItem("RequestTypeStage", JSON.stringify(requestTypes));
        localStorage.setItem(
          "RequestTypeDocs",
          JSON.stringify(requestTypesDocs)
        );
        if (requestTypes.length === 0) {
          return setStageScreen("MultipleRequestTypes");
        }
        setStageScreen(requestTypes[0]);
      } else {
        const resp = await getModifyStage();
        setIsContinue(true);
        setStep(resp);
      }
    } else {
      handleCreateRequest();
    }
  };

  return (
    <div>
      <Title title="Nominee Modification Request" />
      <div className="col-md-12 mt-3">
        <div className="ml-2">
          {prevReqData && (
            <div>
              {/* <div className="row mt-4">
                <div className="row">
                  <h5 className="col-sm">Doctype name</h5>
                  <div className="col-sm">{prevReqData.doctype_name}</div>
                </div>
              </div> */}
              <div className="row mt-4">
                <h5 className="text-bold m-0">User Details</h5>
                <div className="row mt-2">
                  <h6 className="col-sm">Full Name</h6>
                  <div className="col-sm">{prevReqData.full_name}</div>
                </div>
                <div className="row mt-2">
                  <h6 className="col-sm">Mobile Number</h6>
                  <div className="col-sm">
                    {prevReqData.active_mobile_number?.slice(2)}
                  </div>
                </div>
                <div className="row mt-2">
                  <h6 className="col-sm">Email Address</h6>
                  <div className="col-sm">{prevReqData.active_email}</div>
                </div>
                <div className="row mt-2">
                  <h6 className="col-sm">PAN Number</h6>
                  <div className="col-sm">{prevReqData.active_pan_no}</div>
                </div>
                {prevReqData?.Nominee_details?.length > 0 && (
                  <div className="row mt-2">
                    <div className="row">
                      <h6 className="col-sm m-0">Nominee Details:</h6>
                    </div>
                    <table className="table mx-2 my-2">
                      <thead>
                        <tr>
                          {/* <th scope="col">Sr.no</th> */}
                          <th scope="col">Name</th>
                          <th scope="col">Mobile Number</th>
                          <th scope="col">Date of birth</th>
                          <th scope="col">Relationship</th>
                          <th scope="col">Share(%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {prevReqData.Nominee_details.map((item, index) => {
                          return (
                            <tr key={index}>
                              {/* <th scope="row">{index + 1}</th> */}
                              <td>{item.nominee_name}</td>
                              <td>{item.mobile}</td>
                              <td>
                                {item.nominee_dob
                                  ?.split("-")
                                  .reverse()
                                  .join("-")}
                              </td>
                              <td>{item.relationship_with_applicant}</td>
                              <td>{item.share_of__nominee}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              <div className="row mt-2">
                <div className="row">
                  <h6 className="col-sm">Request Number</h6>
                  <div className="col-sm">
                    {prevReqData.rekyc_modi_request_name}
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="row">
                  <h6 className="col-sm">Status</h6>
                  <div className="col-sm">{prevReqData.status}</div>
                </div>
              </div>
            </div>
          )}
          {!isLoading && (
            <div className="d-flex mt-4">
              <div className="">
                <Button
                  type="button"
                  title="Back"
                  handleClick={() => setStep("ActiveUserInfo")}
                  disabled={isLoading}
                />
              </div>
              <div className="mx-2">
                <Button
                  title="Create new request"
                  handleClick={() => onSubmit("No")}
                  loading={isLoading}
                />
              </div>
              <div className="">
                <Button
                  title="Continue"
                  handleClick={() => onSubmit("Yes")}
                  loading={isLoading}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CheckPrevRequest;
